module.exports = __webpack_public_path__ + "static/media/poll-empty.16086952.png";